// Static list of major rental car vendors with Travelport supplier codes.
// Used for the discount brand selector so it works regardless of what vendors
// appear in the current results (e.g. after a discounted search only shows one vendor).
export const RENTAL_VENDOR_OPTIONS: { value: string; label: string }[] = [
  { value: "AL", label: "Alamo" },
  { value: "ZI", label: "Avis" },
  { value: "ZD", label: "Budget" },
  { value: "ZA", label: "Dollar" },
  { value: "ET", label: "Enterprise" },
  { value: "EP", label: "Europcar" },
  { value: "ZE", label: "Hertz" },
  { value: "ZL", label: "National" },
  { value: "SX", label: "Sixt" },
  { value: "ZT", label: "Thrifty" },
];
